import { SvgIconProps } from './icon-props';

const CollapseUpIcon = (props: SvgIconProps) => {
	const { fill = '#4D4D4D', height = 15, width = 15 } = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="5 5 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				transform="rotate(180 10 10)"
				d="M3.38584 10.5L2 10.497L7.5059 5.5L13 10.497H11.6302L3.38584 10.5Z"
				fill={fill}
			/>
		</svg>
	);
};

export default CollapseUpIcon;
